import { AgChartOptions } from 'ag-charts-enterprise';
import { AG_CHARTS_LOCALE_FR_FR } from 'ag-charts-locale';
import { AgCharts } from 'ag-charts-react';
import React from 'react';
import { useTheme } from '../../hooks/useTheme';

interface GenericAgChartProps {
    options: AgChartOptions | null;
    className?: string;
    style?: React.CSSProperties;
}

const GenericAgChart: React.FC<GenericAgChartProps> = ({ options, className, style }) => {
    const { agChartTheme } = useTheme();
    return (
        <div className={className} style={{ borderRadius: 10, overflow: 'hidden', ...style }}>
            <AgCharts
                options={{
                    theme: agChartTheme,
                    locale: {
                        localeText: AG_CHARTS_LOCALE_FR_FR,
                    },
                    zoom: {
                        enabled: true,
                        axes: 'xy',
                        anchorPointX: 'pointer',
                        anchorPointY: 'pointer',
                        enableAxisDragging: true,
                        enablePanning: true,
                        enableScrolling: true,
                        enableDoubleClickToReset: true,
                        enableSelecting: false,
                        enableTwoFingerZoom: true,
                    },
                    background: {
                        visible: false,
                    },
                    ...options,
                }}
            />
        </div>
    );
};

export default GenericAgChart;
